// src/config/config.schema.ts

import { z } from 'zod';

export const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  VITE_MSW_BASE_URL: z.string().url(),
  VITE_DOWNLOAD_LIMIT: z.string().transform((value) => parseInt(value, 10)),
  VITE_IS_MSW: z.string().transform((value) => value === 'true'),
  VITE_AUTH_IS_MSW: z.string().transform((value) => value === 'true'),
  VITE_USER_IS_MSW: z.string().transform((value) => value === 'true'),
  VITE_CUSTOMER_IS_MSW: z.string().transform((value) => value === 'true'),
  VITE_SOURCES_IS_MSW: z.string().transform((value) => value === 'true'),
  VITE_FUNDING_IS_MSW: z.string().transform((value) => value === 'true'),
  VITE_DOCUMENTS_SHOW_ALL: z.string().transform((value) => value === 'true'),
});
